import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponService } from './../../../services/campaign/coupon.service';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.css']
})
export class CouponListComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  showEditForm = false;
  couponToEdit: any;
  @ViewChild('table') table: KontableComponent;

  constructor(
    public couponService: CouponService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    couponService.messageInstanceId = activatedRoute.snapshot.params['messageInstanceId'];
  }

  ngOnInit() {
  }

  openEditForm(coupon: any) {
    this.couponToEdit = coupon;
    this.showEditForm = true;
  }

  saveCoupon(couponData: any) {
    this.couponService.editCoupon(couponData).subscribe(() => {
      this.table.refresh();
      this.showEditForm = false;
    });
  }

  deleteCoupon(couponData: any) {
    this.couponService.deleteCoupon(couponData.id).subscribe(() => this.table.refresh());
  }

  goBack() {
    this.router.navigate(['campaign-list-2']);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-list/coupon-list.component.ts